import React, {useState} from "react"; 
import {Carousel} from "react-bootstrap";
import './stylesheets/Carousel.css';
import { BrowserView, MobileView } from 'react-device-detect';

const data = [
  {
   image: require('./images/Canva1.jpg'), 
   caption:"Whistlin' Dixie bar and dancehall",
   description:"Branding for a bar and dancehall planned in Corpus Christi, Texas"
  },
  {
    image:require('./images/Canva3.jpg'), 
    caption:"TXDoT 'Plan a Sober Ride' campaign",
    description:"TXDoT 'Plan a Sober Ride' campaign marketing material- for GDC Marketing and Ideation"
   },
   {
    image:require('./images/Canva4.jpg'), 
    caption:"The Find Project",
    description:"The Find Project logo and proposed materials"
   },
   {
   image: require('./images/Canva5.jpg'), 
   caption:"TDECU Stadium marketing material",
   description:"Fold-out flyer highlighting the TDECU Bank and University of Houston partnership- for GDC Marketing and Ideation"
  },
  {
    image:require('./images/Canva6.jpg'), 
    caption:"P&G Beauty Powers tradeshow banners",
    description:"P&G tradeshow banners highlighting make-up products- for GDC Marketing and Ideation"
   },
   {
    image:require('./images/Canva7.jpg'), 
    caption:"City of Wimberley welcome sign",
    description:"Spec work- City of Wimberley interactive signage"
   },
   {
   image: require('./images/Canva8.jpg'), 
   caption:"Houston Ballet Nutcracker logo",
   description:"Spec work- The Houston Ballet presents The Nutracker logo"
  },
  {
    image:require('./images/Canva9.jpg'), 
    caption:"Snack Pack 'Better in Packs' ad campaign",
    description:"Spec work- Print ad series for Snack Pack pudding"
   },
   {
    image:require('./images/Canva10.jpg'), 
    caption:"Dynasty CrossFit logo",
    description:"Logo for CrossFit gym in Gainesville, Florida- for Blonde Creative"
   },
   {
   image: require('./images/Canva2.jpg'), 
   caption:"BHS Fiesta medal",
   description:"Baptist Health System medal- for GDC Marketing and Ideation"
  }
]

function HomeCarousel() {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <>
    <BrowserView>
      <Carousel activeIndex={index} onSelect={handleSelect} className= 'carousel'>
       {data.map((slide, i) => {
        return (
          
        <Carousel.Item className="carouselItem">        
          <img 
            className="d-block"
            src={slide.image}
            alt="slider image"
          />
        <Carousel.Caption className="carouselCaption">
          <h3 className= "caption">{slide.caption}</h3>
          <p className= "description">{slide.description}</p>
        </Carousel.Caption>
      </Carousel.Item>
        )
      })}
      
      </Carousel>
    </BrowserView>
    <MobileView>
      <Carousel activeIndex={index} onSelect={handleSelect} className= 'mobileCarousel'>
       {data.map((slide, i) => {
        return (
          
        <Carousel.Item className="carouselItem">        
          <img 
            className="d-block"
            src={slide.image}
            alt="slider image"
          />
        <Carousel.Caption className="mobileCarouselCaption">
          <h3 className= "caption">{slide.caption}</h3>
          <p className= "description">{slide.description}</p>
        </Carousel.Caption>
      </Carousel.Item>
        )
      })}
      
      </Carousel>
    </MobileView>
    </>
  );
}

export default HomeCarousel;